import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { Product } from "@zp-models/product";

@Component({
  selector: "app-system-coupling",
  templateUrl: "./system-coupling.component.html",
  imports: [TranslateModule, CommonModule],
})
export class SystemCouplingComponent {
  @Input() isMobileView = false;
  @Input() advicedProduct: Product;
}
